import React from "react";
import {
  BarChart,
  Bar,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";
import "./chart.css";

const renderColorfulLegendText = (value, entry) => {
  return (
    <span style={{ color: entry.color }} className="barChartLegend">
      {value}
    </span>
  );
};

const RenderLegend = (props) => {
  const { payload } = props;
  return (
    <div className="poll_survey_barChart_legend_main_box" style={{ marginBottom: 50 }}>
      <div className="poll_survey_barChart_legend_title">{props.title}</div>
      <div className="poll_survey_barChart_legend_box">
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            className="poll_survey_barChart_legend_box_item"
          >
            <div
              className="poll_survey_barChart_legend_box_item_dot"
              style={{ backgroundColor: entry.color }}
            />
            {props.external.find((i) => i.data_key === entry.dataKey)
              ? props.external.find((i) => i.data_key === entry.dataKey).title
              : entry.value}
          </div>
        ))}
      </div>
    </div>
  );
};

const RenderTooltip = ({ active, payload, external }) => {
  if (active && payload && payload.length) {
    return (
      <div className="barchart_tooltip_main_box">
        {payload.map((item, index) => (
          <div className="barchart_tooltip_text" key={index}>
            {external.find((j) => j.data_key === item.dataKey)
              ? external.find((j) => j.data_key === item.dataKey).title
              : item.name}
            : {external.find((j) => j.data_key === item.dataKey).percent}
          </div>
        ))}
      </div>
    );
  }
  return null;
};

export const PollSurveyStackedBarChartComponents = ({ data, config }) => {
  return (
    <ResponsiveContainer width="100%" height={100} style={{ zIndex: 9999, position: 'relative' }}>
      <BarChart
        layout="vertical"
        data={data}
        margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
      >
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="name" hide />
        <Tooltip content={<RenderTooltip external={config?.config || []} />} />
        <Legend
          content={
            <RenderLegend
              external={config?.config || []}
              isShowLegend={config?.legend}
              type={config?.legend_type}
              title={config?.graph_title}
            />
          }
          verticalAlign="top"
          align="right"
          iconType="circle"
          formatter={renderColorfulLegendText}
        />
        {(config?.config || []).map((item, index) => (
          <Bar
            key={index}
            dataKey={item.data_key}
            stackId="a"
            fill={item.color}
            barSize={30} // controls the height of the bar
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};
